var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "313A7D36-C447-4484-BB7A-8B2341C6837C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu:-main",
    transform: "translate(-21.000000, -115.000000)",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon.home",
    transform: "translate(22.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-1.41969769e-14 12 -1.41969769e-14 5 6 4.97935027e-14 12 5 12 12 7 12 7 8 5 8 5 12"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.d460fa87a4b06e40f09a2e69a508ae76.svg";
export { ForwardRef as ReactComponent };